import {Injectable} from '@angular/core';
import {GTMEvent} from "./gtm-event";
import {GoogleTagManagerService} from "angular-google-tag-manager";
import {SelectItem} from "../interface/select-item";
import {ViewItem} from "../interface/view-item";
import {ViewItemDataCarrier} from "../interface/carrier/view-item-data-carrier";

@Injectable({
	providedIn: 'root'
})
export class ViewItemService extends GTMEvent {

	constructor(
		public gtm: GoogleTagManagerService
	) {
		super(gtm);
	}

	private _prepareDataLayer(data: ViewItemDataCarrier): ViewItem {
		return {
			event: 'view_item',
			ecommerce: {
				currency: data.currency,
				value: data.price, // should be price * quantity
				items: [{
					item_id: data.product.sku,
					item_name: data.product.name,
					affiliation: 'Anuprerna Website Store',
					discount: 0,
					index: 0,
					item_category: data.product.category.name,
					item_category2: data.product.subCategory.name,
					item_category3: data.product.segment.name,
					price: data.price,
					quantity: 1 // add minimum quantity associated with product
				}]
			}
		};
	}

	public push(data: ViewItemDataCarrier): void {
		super.clearDataLayer();
		this
			.gtm
			.pushTag(this._prepareDataLayer(data))
			.then(onerror => console.error('GTM view_item failed!'));
	}
}
